import React, { useEffect, useState, useMemo } from "react";
import { Labelbox, Table, FrameBox, InfoTable, Button } from "../../components";
import { Grid, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { CLIENT_REFERRAL_ACTION } from "../../redux/action";
import ValidationLibrary from "../../utils/validationfunction";
import { Toaster, dateTimeFormatter } from "../../utils/common";

const useStyes = makeStyles((theme) => ({
  margin: {
    [theme.breakpoints.up("md")]: {
      marginTop: "1rem",
    },
  },
}));

const Feedback = () => {
 
  return (
    <>
      <FrameBox title="Feedback">
        
      </FrameBox>
    </>
  );
};

export default Feedback;
